import { useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ShedManagementState'
import { CheckBox, IndeterminateCheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'
import { SelectedLocations } from '../../ShedManagementTypes'
import { Typography } from '@mui/material'
import LocationsTable from '../LocationsTable/LocationsTable'
import CheckboxAttributes from '../CheckboxAttributes/CheckboxAttributes'
import ContainerCheckbox from '../ContainerCheckbox/ContainerCheckbox'
import CheckboxBooleanAttributes from '../CheckboxBooleanAttributes/CheckboxBooleanAttributes'
import FormControlHeightType from '../FormControlHeightType/FormControlHeightType'
import ContainerCharacteristics from '../ContainerCharacteristics/ContainerCharacteristics'
import MainContainer from '../MainContainer/MainContainer'
import InformationCaption from '../InformationCaption/InformationCaption'
import ConfirmOrRejectModal from '../../../base/components/ConfirmOrRejectModal'
import ErrorLog from '../../../../components/ErrorLog/ErrorLog'
import * as S from './FormUpdateAttributesLocations.styles'

const FormUpdateAttributesLocations = () => {
  const [openModalConfirm, setOpenModalConfirm] = useState(false)
  const { handleSubmit } = useForm()
  const { attributesGroup, selectedLocations, locationAttributeDiscrepancyErrors } = useSelector((state) => state.shedManagement)
  const dispatch = useDispatch()

  const rows = useMemo(() =>
    locationAttributeDiscrepancyErrors.map(({
      locationAddress, missingTypes, heightType,
    }) => ({
      locationAddress, missingTypes, heightType,
    })), [locationAttributeDiscrepancyErrors])

  const onSubmit = () => {
    dispatch(actions.saveAttributesLocations(selectedLocations))
    setOpenModalConfirm(false)
  }

  const updateSelectedLocations = (selectedItems: SelectedLocations[]) => {
    dispatch(actions.setSelectedLocations({ selectedLocations: selectedItems }))
  }

  return (
    <MainContainer
      onSubmit={onSubmit}
      handleSubmit={handleSubmit}
    >
      <S.Container>
        <LocationsTable maxHeight='64vh'/>
        <ContainerCharacteristics label='Características' width='32%'>
          {
            attributesGroup.map((group) => (
              <CheckboxAttributes key={group.groupName} label={group.groupName} attributes={group.values} />
            ))
          }
          <ContainerCheckbox label='Especial'>
            <CheckboxBooleanAttributes
              label='É gôndola'
              property='isGondola'
              items={selectedLocations}
              updateSelectedItems={updateSelectedLocations}
            />
            <CheckboxBooleanAttributes
              label='É fresh'
              property='isFresh'
              items={selectedLocations}
              updateSelectedItems={updateSelectedLocations}
            />
          </ContainerCheckbox>
          <FormControlHeightType />
          <S.ContainerCharacteristicsFooter>
            <S.TotalSelectedQuantityInfo>
              Localizações selecionadas: {selectedLocations.length}
            </S.TotalSelectedQuantityInfo>
            <S.CustomButton
              title='Salvar'
              type='button'
              onClick={() => setOpenModalConfirm(true)}
              bgColor='blue'
              hoverColor='darkBlueHover'
              letterColor='white'
              data-testid='save-location-attributes'
              disabled={selectedLocations.length < 1}
            />
          </S.ContainerCharacteristicsFooter>
        </ContainerCharacteristics>
        <InformationCaption
          moreInformation={(
            <>
              <Typography>
                Localizações que não possuem a opção é gôndola,
                automaticamente são do tipo excedente.
              </Typography>
              <Typography>
                Ao selecionar localizações, que tiverem atributos
                de alturas diferentes, a seleção de opção ficará bloqueada.
              </Typography>
              <Typography><strong>Média</strong> - necessidade de escada.</Typography>
              <Typography><strong>Alta</strong> - necessidade de empilhadeira.</Typography>
            </>
          )}
          width='20%'
        />
        <ConfirmOrRejectModal
          show={openModalConfirm}
          title='Confirmação de atributos'
          customizableDescription={(
            <S.ContainerDescription>
              <S.ContainerItems>
                <S.Item>
                  <p>Atributos com estado </p>
                  <CheckBox color='info'/>
                  <p>serão aplicados em todas as localizações selecionadas.</p>
                </S.Item>
                <S.Item>
                  <p>Atributos com estado </p>
                  <IndeterminateCheckBox color='info'/>
                  <p>serão mantidas as configurações originais.</p>
                </S.Item>
                <S.Item>
                  <p>Atributos com estado </p>
                  <CheckBoxOutlineBlank color='info'/>
                  <p>serão removidos nas localizações selecionadas.</p>
                </S.Item>
              </S.ContainerItems>
              <p>
                Deseja prosseguir?
              </p>
            </S.ContainerDescription>
          )}
          onConfirm={onSubmit}
          onReject={() => setOpenModalConfirm(false)}
          onClose={() => setOpenModalConfirm(false)}
          dataTestId='modal-confirmation-attributes'
          size='lg'
        />
      </S.Container>
      {
        locationAttributeDiscrepancyErrors.length > 0
          && (
            <ErrorLog
              label='Logs'
              columns={[
                { id: 'locationAddress', label: 'Endereço' },
                { id: 'missingTypes', label: 'Atributos em falta' },
                { id: 'heightType', label: 'Altura' },
              ]}
              rows={rows}
              width='38.6%'
            />
          )
      }
    </MainContainer>
  )
}

export default FormUpdateAttributesLocations
